import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

class GradedSmiley extends React.Component {
	render () {
      var smiley = <i></i>;
      var classes = "";
      var color = {};
      var datasmiley = "";
      if(this.props.smiley_score >= 85){
          classes="fas fa-laugh smiley_rate"; 
          color='#01de1c'; 
        } else if(this.props.smiley_score >= 70 && this.props.smiley_score < 85){
          classes="fas fa-grin smiley_rate"; 
          color='#33f502'; 
        } else if(this.props.smiley_score >= 55 && this.props.smiley_score < 70){
          classes="fas fa-smile smiley_rate"; 
          color='#abef0e'; 
        } else if(this.props.smiley_score >= 45 && this.props.smiley_score < 55){
          classes="fas fa-meh smiley_rate"; 
          color='#b5b5b5'; 
        } else if(this.props.smiley_score >= 30 && this.props.smiley_score < 45){
          classes="fas fa-frown smiley_rate"; 
          color='#ffcf08'; 
        } else if(this.props.smiley_score >= 15 && this.props.smiley_score < 30){
          classes="fas fa-frown-open smiley_rate"; 
          color='#fe0100'; 
        } else if(this.props.smiley_score >= 0 && this.props.smiley_score < 15){
          classes="fas fa-angry  smiley_rate"; 
          color='#b30101'; 
        }

      if(this.props.smiley_score != null) {
       smiley = <i className={classes + " pl-0 pr-2 ml-0"} style={{color: color}}></i>
      }
		return ( smiley );
    }
}

export default GradedSmiley;